import { Link } from "react-router-dom";

/** Datum aus YYYY-MM-DD → "22. Juni 2025" */
function formatDatum(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  const monate = ["", "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
  return `${parseInt(d)}. ${monate[parseInt(m)]} ${y}`;
}

/**
 * Grosse Hero-Karte für den gepinnten/featured News-Artikel.
 * Wird oben auf der News-Seite angezeigt, wenn ein Artikel "gepinnt" ist.
 */
export default function FeaturedNewsCard({ artikel }) {
  const bildUrl = artikel.photoUrls?.[0] || null;

  return (
    <Link
      to={`/news/${artikel.slug}`}
      className="group relative block overflow-hidden bg-primary"
    >
      <div className="relative h-[340px] md:h-[420px] w-full">
        {bildUrl && (
          <img
            src={bildUrl}
            alt={artikel.title}
            loading="eager"
            fetchpriority="high"
            decoding="async"
            className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
          />
        )}
        {/* Verlauf für Lesbarkeit */}
        <div className="absolute inset-0 bg-gradient-to-t from-dark/90 via-dark/40 to-transparent" />

        <div className="relative h-full flex flex-col justify-end p-6 md:p-10">
          <div className="flex flex-wrap items-center gap-3 mb-4">
            <span className="inline-flex items-center gap-1.5 bg-accent text-white text-xs font-bold uppercase tracking-widest px-3 py-1.5">
              <svg className="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2a1 1 0 011 1v6.5l3.7 2.15a1 1 0 01-1 1.73L12 11 8.3 13.38a1 1 0 01-1-1.73L11 9.5V3a1 1 0 011-1z" />
              </svg>
              Gepinnter Beitrag
            </span>
            {artikel.kategorie && (
              <span className="bg-white/15 text-white text-xs font-bold uppercase tracking-wide px-3 py-1.5">
                {artikel.kategorie}
              </span>
            )}
          </div>

          <h2 className="text-2xl md:text-4xl font-extrabold uppercase leading-tight text-white max-w-3xl">
            {artikel.title}
          </h2>

          <div className="mt-4 flex items-center justify-between gap-4">
            <span className="text-white/70 text-sm">{formatDatum(artikel.date)}</span>
            <span className="inline-flex items-center gap-1 text-sm font-bold uppercase tracking-wide text-white group-hover:text-accent transition-colors">
              Weiterlesen
              <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
